function createAction(name) {
  return `@@formCloning/${name}`;
}
export const REQUEST_FORM_CLONING = createAction('REQUEST_FORM_CLONING');
export const SUCCEED_CLONING_FORM = createAction('SUCCEED_CLONING_FORM');
export const FAIL_CLONING_FORM = createAction('FAIL_CLONING_FORM');
export const RESET_FORM_CLONING_STATE = createAction('RESET_FORM_CLONING_STATE');
export const START_TRANSLATING = createAction('START_TRANSLATING');
export const FINISH_TRANSLATING = createAction('FINISH_TRANSLATING');
export const startTranslating = () => ({
  type: START_TRANSLATING
});
export const finishTranslating = () => ({
  type: FINISH_TRANSLATING
});